import React from 'react'
import styled from '@emotion/styled'
import { useQuery, gql } from '@apollo/client'
import { space, useTransition, easing, Alert } from '@ticketswap/solar'
import { createMarkup } from '~/utils'

const duration = 200

const Container = styled.div`
  position: relative;
  opacity: ${props => (props.state === 'entering' || props.state === 'entered' ? 1 : 0)};
  transition-duration: ${duration}ms;
  transition-timing-function: ${easing.easeOutCubic};
  transition-property: opacity;
  margin-top: ${space[16]};
`

const AnnouncementAlert = styled(Alert)`
  text-align: left;
`

const GET_HOMEPAGE_ANNOUNCEMENT = gql`
  query getHomepageAnnouncement {
    announcement(type: HOME) {
      text
    }
  }
`

const HomepageAnnouncement = React.memo(() => {
  const { data = {}, loading } = useQuery(GET_HOMEPAGE_ANNOUNCEMENT)
  const { announcement = {} } = data
  const [state, mounted] = useTransition({
    in: Boolean(announcement.text),
    timeout: duration,
  })
  if (loading) return null

  return (
    <>
      {mounted && (
        <Container state={state}>
          <AnnouncementAlert variant="warning">
            <span
              dangerouslySetInnerHTML={createMarkup(announcement.text, {
                renderInline: true,
              })}
            />
          </AnnouncementAlert>
        </Container>
      )}
    </>
  )
})

export default HomepageAnnouncement
